<div class="app-sidebar" [class.collapsed]="collapsed">
    <div class="sidebar-upper-part">
        <div class="sidebar-header" *ngIf="sidebarConfiguration?.header">{{sidebarConfiguration.header}}</div>
        <div class="sidebar-sub-header" *ngIf="sidebarConfiguration?.subHeader">{{sidebarConfiguration.subHeader}}</div>
        <div class="sidebar-item-list">
            <ul>
                <li *ngFor="let item of sidebarConfiguration.items">
                    <strong class="sidebar-category" *ngIf="item.category"><i *ngIf="item.icon" class="{{item.icon}}"></i>{{item.label}}</strong>
            
                    <div class="sidebar-spacer" *ngIf="item.spacer"></div>
                    <span class="sidebar-item" *ngIf="!item.category && !item.divider && !item.spacer && !item.link" (click)="item?.command()"><i *ngIf="item.icon" class="{{item.icon}}"></i>{{item.label}}</span>
                    <a class="sidebar-item" *ngIf="!item.category && !item.divider && !item.spacer && item.link" target="_blank" href="{{item.link}}"><i *ngIf="item.icon" class="{{item.icon}}"></i>{{item.label}}</a>
                </li>
            </ul>
        </div>
    </div>

    <ng-container *ngIf="sidebarFooterTemplate">
    <div class="sidebar-footer">
        <ng-container *ngTemplateOutlet="sidebarFooterTemplate"></ng-container>
    </div>
    </ng-container>

    <div class="sidebar-handle" (click)="toggleSidebar()" title="Collapse sidebar">
        <span>&#10094;</span>
    </div>
</div>